
































































































































































































































































import {
  computed,
  defineComponent, PropType, Ref, ref, watch,
} from 'vue';
import { EdgesSpec } from 'multinet';

import api from '@/api';
import { KeyValue } from '@/types';
import WorkspaceOptionMenu from '@/components/WorkspaceOptionMenu.vue';

// interface EdgeRecord {
//   id: string;
//   from: string;
//   to: string;
// }

interface Connection {
  id: string;
  node: string;
}

type EdgeType = 'incoming' | 'outgoing';

export default defineComponent({
  name: 'NodeDetail',

  components: {
    WorkspaceOptionMenu,
  },

  props: {
    workspace: {
      type: String as PropType<string>,
      required: true,
    },

    network: {
      type: String as PropType<string>,
      required: true,
    },

    type: {
      type: String as PropType<string>,
      required: true,
    },

    node: {
      type: String as PropType<string>,
      required: true,
    },
  },
  setup(props) {
    const incoming: Ref<Connection[]> = ref([]);
    const outgoing: Ref<Connection[]> = ref([]);
    const attributes: Ref<KeyValue[]> = ref([]);
    const offsetIncoming = ref(0);
    const offsetOutgoing = ref(0);
    const pageCount = ref(20);
    const totalIncoming = ref(0);
    const totalOutgoing = ref(0);
    const loading = ref(true);

    function computePageNumber(offset: number) {
      return Math.floor(offset / pageCount.value);
    }

    const lastIncomingPage = computed(() => computePageNumber(totalIncoming.value) * pageCount.value);
    const lastOutgoingPage = computed(() => computePageNumber(totalOutgoing.value) * pageCount.value);
    const nextIncoming = computed(() => lastIncomingPage.value !== offsetIncoming.value);
    const nextOutgoing = computed(() => lastOutgoingPage.value !== offsetOutgoing.value);
    const prevIncoming = computed(() => offsetIncoming.value !== 0);
    const prevOutgoing = computed(() => offsetOutgoing.value !== 0);
    const currentIncomingPageNumber = computed(() => computePageNumber(offsetIncoming.value) + 1);
    const lastIncomingPageNumber = computed(() => computePageNumber(totalIncoming.value) + 1);
    const currentOutgoingPageNumber = computed(() => computePageNumber(offsetOutgoing.value) + 1);
    const lastOutgoingPageNumber = computed(() => computePageNumber(totalOutgoing.value) + 1);
    const attributeTable = computed(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const table: { [key: string]: any } = {};
      attributes.value.forEach((entry) => {
        table[entry.key] = entry.value;
      });

      return table;
    });

    async function update() {
      loading.value = true;
      const nodeTable = (await api.table(props.workspace, props.type, {})).results;
      // eslint-disable-next-line no-underscore-dangle
      const newNode = nodeTable.find((table) => table._key === props.node);
      const newIncoming = (await api.edges(props.workspace, props.network, {
        direction: 'incoming',
        offset: offsetIncoming.value,
        limit: pageCount.value,
      // eslint-disable-next-line no-underscore-dangle
      })).results.filter((edge) => edge._to === `${props.type}/${props.node}`);
      const newOutgoing = (await api.edges(props.workspace, props.network, {
        direction: 'outgoing',
        offset: offsetOutgoing.value,
        limit: pageCount.value,
      // eslint-disable-next-line no-underscore-dangle
      })).results.filter((edge) => edge._from === `${props.type}/${props.node}`);

      // eslint-disable-next-line no-underscore-dangle
      if (newNode) {
        attributes.value = Object.entries(newNode).filter(([key]) => key !== '_rev').map(([key, value]) => ({
          key,
          value,
        }));
      }

      // eslint-disable-next-line no-underscore-dangle
      incoming.value = newIncoming.map((edge: EdgesSpec) => ({ id: edge._id, node: edge._from }));
      // eslint-disable-next-line no-underscore-dangle
      outgoing.value = newOutgoing.map((edge: EdgesSpec) => ({ id: edge._id, node: edge._to }));
      totalIncoming.value = incoming.value.length;
      totalOutgoing.value = outgoing.value.length;

      loading.value = false;
    }
    function turnPage(edgeType: EdgeType, forward: number) {
      if (edgeType === 'incoming') {
        offsetIncoming.value += forward ? pageCount.value : -pageCount.value;
      } else if (edgeType === 'outgoing') {
        offsetOutgoing.value += forward ? pageCount.value : -pageCount.value;
      }
    }
    function lastPage(edgeType: EdgeType) {
      if (edgeType === 'incoming') {
        offsetIncoming.value = lastIncomingPage.value;
      } else if (edgeType === 'outgoing') {
        offsetOutgoing.value = lastOutgoingPage.value;
      }
    }
    function firstPage(edgeType: EdgeType) {
      if (edgeType === 'incoming') {
        offsetIncoming.value = 0;
      } else if (edgeType === 'outgoing') {
        offsetOutgoing.value = 0;
      }
    }

    watch([() => props.workspace, () => props.network, () => props.type, () => props.node, offsetIncoming, offsetOutgoing, pageCount], () => update());

    update();

    return {
      incoming,
      outgoing,
      attributes,
      offsetIncoming,
      offsetOutgoing,
      pageCount,
      totalIncoming,
      totalOutgoing,
      loading,
      attributeTable,
      nextIncoming,
      nextOutgoing,
      prevIncoming,
      prevOutgoing,
      lastIncomingPageNumber,
      lastOutgoingPageNumber,
      currentIncomingPageNumber,
      currentOutgoingPageNumber,
      turnPage,
      firstPage,
      lastPage,
    };
  },
});
